// extracted by mini-css-extract-plugin
export default {"image":"x0-z","loaded":"y0-z"};